
import React, { useEffect, useState } from "react";
import ControlCentrePage from "../../entities/ControlCentre";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";
import LoaderHelper from "../../utils/Loader/LoaderHelper";


const ControlCentre = () => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [countryData, setCountryData] = useState(null)
  const [taxLabel, setTaxLabel] = useState();

  useEffect(() => {
    getSelectedCountries()
    getAllTaxLabel()
  },[])

  const handleCountrySelection = async (countries) => {
    setLoading(true);
    try {
      const result = await AuthService.handleCountrySelection(countries);
      if (result?.success) {
        showAlert(result?.message, "success")
        setLoading(false);
        getSelectedCountries();
      } else {
        showAlert(result?.message, "success")
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getSelectedCountries = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getSelectedCountries();
      if (result?.success) {
        const selectedData = result?.data?.countrySelections?.[0]
        setCountryData(selectedData?.countries)
        // setData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };

  const getAllTaxLabel = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getAllTaxLabel();
      if (result?.success) {
        setTaxLabel(result?.data)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message,"success")
      } else {
        showAlert(result?.message,"error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const handleAddTaxLabel = async (rate, country) => {
    setLoading(true);
    try {
      const result = await AuthService.addTaxLabel(rate,country);
      if (result?.success === true) {
        setLoading(false);
        getAllTaxLabel()
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  return (
    <>
      <ControlCentrePage handleCountrySelection={handleCountrySelection} taxLabel={taxLabel} handleAddTaxLabel={handleAddTaxLabel} countryData={countryData} loading={loading}/>

    </>
  );
};

export default ControlCentre;
